/* eslint-disable @typescript-eslint/quotes */
import React from "react";
import {
  FacebookIcon,
  GithubIcon,
  InstagramIcon,
  LinkedinIcon,
  TwitterIcon,
  YoutubeIcon,
} from "./SVGIcons";

interface Props {
  network: 'instagram' | 'facebook' | 'twitter' | 'linkedin' | 'github' | 'youtube';
  color: "primary" | "inherit" | "secondary" | string;
  // fontSize: "inherit" | "default" | "small" | "large";
}

const SocialNetworkIcon = ({ network, color }: Props) => {
  switch (network.toLowerCase()) {
    case "github":
      return <GithubIcon color={color} />;
    case "facebook":
      return <FacebookIcon color={color} />;
    case "twitter":
      return <TwitterIcon color={color} />;
    case "youtube":
      return <YoutubeIcon color={color} />;
    case "linkedin":
      return <LinkedinIcon color={color} />;
    case "instagram":
      return <InstagramIcon color={color} />;
    default:
      return <LinkedinIcon color={color} />;
  }
};

export default SocialNetworkIcon;
